(function($) {

    $(".nav-toggle").on('click', function () {
        $nav = $("nav.mobile-nav");
        $(this).toggleClass("open");
        $nav.toggleClass('show');
        $('.trigger-search').toggle();
        $('html').toggleClass('mobile-nav-open');
    });


})( jQuery );

